<template>
  <section class="content">
    <div class="container-fluid">
      <div id="calendar"></div>

      <!-- Modal Custom (Tanpa Bootstrap) -->
      <div v-if="showModal" class="modal-overlay">
        <div class="modal-box">
          <h5>Edit Event</h5>
          <input
            v-model="editEventTitle"
            class="form-input"
            placeholder="Judul Event Baru"
          />
          <div class="modal-actions">
            <button @click="deleteEvent" class="btn btn-danger">Hapus</button>
            <button @click="updateEvent" class="btn btn-primary">Simpan</button>
            <button @click="showModal = false" class="btn btn-secondary">
              Batal
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Tambah Event -->
    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal-box">
        <h5>Tambah Event</h5>

        <input
          v-model="newEvent.title"
          class="form-input"
          placeholder="Judul Event"
        />

        <p style="margin-top:10px;font-size:13px;color:#666">
          Tanggal: {{ newEvent.start }} s/d {{ newEvent.end }}
        </p>

        <div class="modal-actions">
          <button @click="saveEvent" class="btn btn-primary">Simpan</button>
          <button @click="cancelAdd" class="btn btn-secondary">Batal</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import api from "@/helper/api";

export default {
  name: "CalendarView",
  data() {
    return {
      calendar: null,
      selectedEvent: null,
      editEventTitle: "",
      showModal: false,
      showAddModal: false,
      newEvent: {
        title: "",
        start: "",
        end: ""
      }
    };
  },
  mounted() {
    const calendarEl = document.getElementById("calendar");

    this.calendar = new window.FullCalendar.Calendar(calendarEl, {
      initialView: "dayGridMonth",
      selectable: true,

      dateClick: info => {
        this.newEvent = {
          title: "",
          start: info.dateStr,
          end: info.dateStr 
        };
        this.showAddModal = true;
      },

      select: info => {
        if (info.startStr === info.endStr) return;

        this.newEvent = {
          title: "",
          start: info.startStr,
          end: info.endStr
        };
        this.showAddModal = true;
      },

      eventClick: info => this.handleEventClick(info)
    });

    this.calendar.render();

    api.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("_token");

    api
      .get("/getallKalender")
      .then(res => {
        res.data.content.forEach(evt => {
          this.calendar.addEvent({
            id: evt.id,
            title: evt.title,
            start: evt.start,
            end: evt.end,
            allDay: true
          });
        });
      })
      .catch(() => {
        this.$toastr.e("Gagal memuat data event");
      });
  },
  methods: {
    saveEvent() {
      if (!this.newEvent.title) {
        this.$toastr.e("Judul event wajib diisi");
        return;
      }

      this.calendar.addEvent({
        title: this.newEvent.title,
        start: this.newEvent.start,
        end: this.newEvent.end,
        allDay: true
      });

      api
        .post("/insertEvent", this.newEvent)
        .then(() => {
          this.$toastr.s("Event berhasil ditambahkan");
        })
        .catch(() => {
          this.$toastr.e("Gagal menyimpan event");
        });

      this.cancelAdd();
    },

    cancelAdd() {
      this.showAddModal = false;
      this.newEvent = { title: "", start: "", end: "" };
    },

    handleEventClick(info) {
      this.selectedEvent = info.event;
      this.editEventTitle = info.event.title;
      this.showModal = true;
    },

    updateEvent() {
      this.selectedEvent.setProp("title", this.editEventTitle);

      api
        .post(`/updateEvent/${this.selectedEvent.id}`, {
          title: this.editEventTitle,
          start: this.selectedEvent.startStr,
          end: this.selectedEvent.endStr
        })
        .then(() => {
          this.$toastr.s("Update berhasil");
        });

      this.showModal = false;
    },

    deleteEvent() {
      const id = this.selectedEvent.id;
      this.selectedEvent.remove();

      api
        .delete(`/deleteEvent/${id}`)
        .then(() => this.$toastr.s("Event dihapus"))
        .catch(() => this.$toastr.e("Gagal hapus event"));

      this.showModal = false;
    }
  }
};
</script>

<style>
#calendar {
  max-width: 900px;
  margin: 40px auto;
  background-color: white;
  padding: 20px;
  border-radius: 20px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-box {
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.btn {
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
}

.form-input {
  width: 100%;
  padding: 8px;
  margin-top: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/Kalender/Calender.vue?1d7d68e7